export default __webpack_public_path__ + "assets/images/c7877e3fcea41789952d93fa38964446.svg";